import { showNotify } from "../../helpers/toast";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { HinhThucMienGiamGroupActionTypeIds, HinhThucMienGiamGroupActionTypes } from "../action-types/hinhThucMienGiamGroupActionTypes";
import { HinhThucMienGiamGroupPageState } from "../page-state-model/hinhThucMienGiamGroupPageState";
const initialState: HinhThucMienGiamGroupPageState = {
    sf_hinhthucmiengiam_groups: [],
    sf_hinhthucmiengiam_group_selected_ids: [],
    status: PageBaseStatus.is_completed
}
export const hinhThucMienGiamGroupReducer = (state: HinhThucMienGiamGroupPageState = initialState, action: HinhThucMienGiamGroupActionTypes): HinhThucMienGiamGroupPageState => {
    switch (action.type) {
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_START:
            return {
                ...state,
                status: PageBaseStatus.is_loading
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_SUCCESS:
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                sf_hinhthucmiengiam_groups: action.payload
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: true,
                sf_hinhthucmiengiam_group_editing: action.payload

            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CLOSE_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: false,

            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DELETE_CONFIRM:
            return {
                ...state,
                is_show_delete_confirm: action.payload
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_START:
            return {
                ...state,
                status: PageBaseStatus.is_saving
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_SUCCESS:
            showNotify({
                message: `${action.payload.id > 0 ? "Cập nhật " : "Thêm mới "} thành công`,
                type: "success"
            })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                sf_hinhthucmiengiam_group_editing: undefined,
                is_show_detail_modal: false

            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
            }

        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_START:
            return {
                ...state,
                status: PageBaseStatus.is_deleting
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_SUCCESSS:
            showNotify({ message: `Xóa thành công`, type: "success" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
                is_show_delete_confirm: false
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_ERROR:
            showNotify({ message: action.payload, type: "error" })
            return {
                ...state,
                status: PageBaseStatus.is_completed,
            }
        case HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CHANGE_SELECTED_IDS:
            return {
                ...state,
                sf_hinhthucmiengiam_group_selected_ids: action.payload
            }
        default:
            return state;
    }
}